import { BaseModel, propertyChangedArguments } from "../BaseModel";

export class EventModel extends BaseModel {

    constructor(source?: EventModel) {
        super();
        if (source != null) {
            this.copyIn(source);
        }
        else
        {
            this._eventID = 0;
            this._eventStatusID = 0;
        }
    }

// private properties
    _eventID: number = 0;
    _eventName: string = "";
    _venueName: string | null = null;
    _address: string | null = null;
    _city: string | null = null;
    _country: string | null = null;
    _startDate: Date = new Date();
    _endDate: Date = new Date();
    _eventStatusID: number = 0;
    _active: boolean = false;
    _createdDate: Date = new Date();

// public properties
    public get eventID(): number
    {
        return this._eventID;
    }
    public set eventID(v: number)
    {
        if (v !== this._eventID)
        {
            this._eventID = v;
            this.propertyChanged.emit(new propertyChangedArguments("eventID", this));
        }
    }

    public get eventName(): string
    {
        return this._eventName;
    }
    public set eventName(v: string)
    {
        if (v !== this._eventName)
        {
            this._eventName = v;
            this.propertyChanged.emit(new propertyChangedArguments("eventName", this));
        }
    }

    public get venueName(): string | null
    {
        return this._venueName;
    }
    public set venueName(v: string | null)
    {
        if (v !== this._venueName)
        {
            this._venueName = v;
            this.propertyChanged.emit(new propertyChangedArguments("venueName", this));
        }
    }

    public get address(): string | null
    {
        return this._address;
    }
    public set address(v: string | null)
    {
        if (v !== this._address)
        {
            this._address = v;
            this.propertyChanged.emit(new propertyChangedArguments("address", this));
        }
    }

    public get city(): string | null
    {
        return this._city;
    }
    public set city(v: string | null)
    {
        if (v !== this._city)
        {
            this._city = v;
            this.propertyChanged.emit(new propertyChangedArguments("city", this));
        }
    }

    public get country(): string | null
    {
        return this._country;
    }
    public set country(v: string | null)
    {
        if (v !== this._country)
        {
            this._country = v;
            this.propertyChanged.emit(new propertyChangedArguments("country", this));
        }
    }

    public get startDate(): Date
    {
        return this._startDate;
    }
    public set startDate(v: Date)
    {
        if (v !== this._startDate)
        {
            this._startDate = v;
            this.propertyChanged.emit(new propertyChangedArguments("startDate", this));
        }
    }

    public get endDate(): Date
    {
        return this._endDate;
    }
    public set endDate(v: Date)
    {
        if (v !== this._endDate)
        {
            this._endDate = v;
            this.propertyChanged.emit(new propertyChangedArguments("endDate", this));
        }
    }

    public get eventStatusID(): number
    {
        return this._eventStatusID;
    }
    public set eventStatusID(v: number)
    {
        if (v !== this._eventStatusID)
        {
            this._eventStatusID = v;
            this.propertyChanged.emit(new propertyChangedArguments("eventStatusID", this));
        }
    }

    public get active(): boolean
    {
        return this._active;
    }
    public set active(v: boolean)
    {
        if (v !== this._active)
        {
            this._active = v;
            this.propertyChanged.emit(new propertyChangedArguments("active", this));
        }
    }

    public get createdDate(): Date
    {
        return this._createdDate;
    }
    public set createdDate(v: Date)
    {
        if (v !== this._createdDate)
        {
            this._createdDate = v;
            this.propertyChanged.emit(new propertyChangedArguments("createdDate", this));
        }
    }


    override assignChildren(): void {
        super.assignChildren();
    }

    copyIn(source: EventModel): void {
        if (source == null) return;
        this._eventID = source.eventID;
        this._eventName = source.eventName;
        this._venueName = source.venueName;
        this._address = source.address;
        this._city = source.city;
        this._country = source.country;
        this._startDate = source.startDate;
        this._endDate = source.endDate;
        this._eventStatusID = source.eventStatusID;
        this._active = source.active;
        this._createdDate = source.createdDate;
    }


}
